export default {
    data() {
        return {
            validationErrors: {},
        };
    },
    computed: {
        hasValidationErrors() {
            return !_.isEmpty(this.validationErrors);
        },
    },
    watch: {
        hasValidationErrors(hasErrors) {
            if (hasErrors) {
                this.$nextTick(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                });
            }
        }
    },
    methods: {
        hasError(field) {
            return _.has(this.validationErrors, field);
        },
        getError(field) {
            return _.get(this.validationErrors, field);
        },
        setValidationErrors(errors) {
            let validationErrors = {};
            _.forEach(errors, (error, keyword) => _.set(validationErrors, keyword, error[0]));

            // assign values this way to trigger change
            this.validationErrors = Object.assign({}, this.validationErrors, validationErrors);
        },
        clearValidationErrors() {
            this.validationErrors = {};
        }
    },
};

export const getters = {
    methods: {
        hasError(field) {
            return _.has(this.validationErrors, field);
        },
        getError(field) {
            return _.get(this.validationErrors, field);
        },
    },
};
